// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/loaders.css/loaders.css
// module id = 1222
// module chunks = 0